
import { throttle } from "lodash"
import { trackProductInteraction } from "@/utils/track"
import emptyImg from "@/assets/images/empty_img.png"
export default {
  name: "PicZoom",
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    curImgView: {
      type: Number,
      default: 0
    },
    ware: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      zoomVisiable: false,
      showMask: false,
      previewImg: emptyImg,
      curImg: 0,
      showArrowLeft: false,
      showArrow: true,
      maskLeft: 0,
      maskTop: 0,
      imgX: 0,
      imgY: 0
    }
  },

  created() {
    this.curImg = this.curImgView
    this.previewImg = this.imgList[this.curImg]?.url
  },
  methods: {
    handleMouseenter(ev) {
      this.showMask = true
      this.zoomVisiable = true
    },
    handleMouseleave() {
      this.showMask = false
      this.zoomVisiable = false
    },
    mousemove: throttle(function (e) {
      const mask = this.$refs.mask
      const bigimg = this.$refs.bigimg
      const big = this.$refs.big
      const small = this.$refs.small

      let maskX = e.pageX - small.getBoundingClientRect().left - mask.offsetWidth / 2
      let maskY = e.pageY - small.getBoundingClientRect().top - mask.offsetHeight / 2

      maskX = Math.max(0, Math.min(maskX, small.offsetWidth - mask.offsetWidth))
      maskY = Math.max(0, Math.min(maskY, small.offsetHeight - mask.offsetHeight))

      const bigImgX = (maskX * (bigimg.offsetWidth - big.offsetWidth)) / (small.offsetWidth - mask.offsetWidth)
      const bigImgY = (maskY * (bigimg.offsetHeight - big.offsetHeight)) / (small.offsetHeight - mask.offsetHeight)

      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)

      this.maskLeft = maskX / rootFontSize
      this.maskTop = maskY / rootFontSize
      this.imgX = bigImgX / rootFontSize
      this.imgY = bigImgY / rootFontSize
    }, 50),
    imgClick(item, index) {
      trackProductInteraction(this.ware)
      this.curImg = index
      this.previewImg = this.imgList[index].url
    },
    onScroll(pos) {
      const length = Math.ceil(Math.abs(pos.x / 52))
      if (pos.x == this.scroll.maxScrollX || (length && length == this.imgList.length - 3)) {
        this.showArrow = false
      } else {
        this.showArrow = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
    },
    handleArrowClick(type) {
      // 单个商品宽度目前为78px
      const num = type === "left" ? 52 : -52
      this.scroll.scrollBy(num, 0, 200)
    }
  }
}
